var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DescriptiveSelector',_vm._g(_vm._b({attrs:{"items":_vm.items,"loading":_vm.loading}},'DescriptiveSelector',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }